export enum Distribution {
  PARALLEL = 'PARALLEL',
  SERIAL = 'SERIAL',
  CIRCULAR = 'CIRCULAR',
  LONGEST_IDLE = 'LONGEST_IDLE',
  RANDOM = 'RANDOM',
}
